import Vue from "vue"

export const state = {
  deliveryStatus: '',
  fleetTaskId: '',
  activities: [],
  importResult: null,

  bulkDeliveryIds: [],
  bulkIdsError: {},

  bulkFormValues: {},
  bulkFullObjects: {},

  bulkItemValues: {},
  bulkItemObjects: {},

  bulkLoadValues: {},
  bulkLoadObjects: {},

  shipmentType: '',
  shipmentTypeFilters: {},
  statusTypeFilters: {},
}

export const mutations = {
  SET_DELIVERYSTATUS(state, payload) {
    state.deliveryStatus = payload
  },
  SET_FLEETTASKID(state, payload) {
    state.fleetTaskId = payload
  },
  SET_ACTIVITIES(state, payload) {
    state.activities = payload
  },
  SET_IMPORTRESULT(state, payload) {
    state.importResult = payload
  },

  SET_BULKDELIVERYIDS(state, payload) {
    state.bulkDeliveryIds = payload
  },
  SET_BULKIDSERROR(state, payload) {
    Vue.set(state.bulkIdsError, payload.key, payload.value)
  },
  DELETE_BULKIDSERROR(state, payload) {
    Vue.delete(state.bulkIdsError, payload.key)
  },

  SET_BULKFORMVALUES(state, payload) {
    Vue.set(state.bulkFormValues, payload.key, payload.value)
  },
  SET_BULKFULLOBJECTS(state, payload) {
    Vue.set(state.bulkFullObjects, payload.key, payload.value)
  },

  SET_BULKITEMVALUES(state, payload) {
    Vue.set(state.bulkItemValues, payload.key, {...payload.value})
  },
  DELETE_BULKITEMVALUES(state, payload) {
    Vue.delete(state.bulkItemValues, payload.key)
  },

  SET_BULKLOADVALUES(state, payload) {
    Vue.set(state.bulkLoadValues, payload.key, [...payload.value])
  },
  DELETE_BULKLOADVALUES(state, payload) {
    Vue.delete(state.bulkLoadValues, payload.key)
  },
  
  SET_BULKITEMOBJECTS(state, payload) {
    Vue.set(state.bulkItemObjects, payload.key, {...payload.value})
  },
  DELETE_BULKITEMOBJECTS(state, payload) {
    Vue.delete(state.bulkItemObjects, payload.key)
  },
  
  SET_BULKLOADOBJECTS(state, payload) {
    Vue.set(state.bulkLoadObjects, payload.key, [...payload.value])
  },
  DELETE_BULKLOADOBJECTS(state, payload) {
    Vue.delete(state.bulkLoadObjects, payload.key)
  },

  RESET_BULK_STATES(state) {
    state.bulkDeliveryId = []
    state.bulkFormValues = {}
    state.bulkFullObjects = {}
    state.bulkItemValues = {}
    state.bulkLoadValues = {}
    state.bulkItemObjects = {}
    state.bulkLoadObjects = {}
  },

  SET_SHIPMENTTYPE(state, payload) {
    state.shipmentType = payload
  },
  
  SET_SHIPMENT_TYPE_FILTERS(state, payload) {
    state.shipmentTypeFilters = payload
  },

  SET_STATUS_TYPE_FILTERS(state, payload) {
    state.statusTypeFilters = payload
  }
}

export const actions = {
  setDeliveryStatus({ commit }, payload) {
    commit('SET_DELIVERYSTATUS', payload)
  },
  setFleetTaskId({ commit }, payload) {
    commit('SET_FLEETTASKID', payload)
  },
  setActivities({ commit }, payload) {
    commit('SET_ACTIVITIES', payload)
  },
  setImportResult({ commit }, payload) {
    commit('SET_IMPORTRESULT', payload)
  },

  setBulkDeliveryIds({ commit }, payload) {
    commit('SET_BULKDELIVERYIDS', payload)
  },
  setBulkIdError({ commit }, payload) {
    commit('SET_BULKIDSERROR', payload)
  },
  deleteBulkIdError({ commit }, payload) {
    commit('DELETE_BULKIDSERROR', payload)
  },

  setBulkFormValues({ commit }, payload) {
    commit('SET_BULKFORMVALUES', payload)
  },
  setBulkFullObjects({ commit }, payload) {
    commit('SET_BULKFULLOBJECTS', payload)
  },

  setBulkItemValues({ commit }, payload) {
    commit('SET_BULKITEMVALUES', payload)
  },
  deleteBulkItemValues({ commit }, payload) {
    commit('DELETE_BULKITEMVALUES', payload)
  },

  setBulkLoadValues({ commit }, payload) {
    commit('SET_BULKLOADVALUES', payload)
  },
  deleteBulkLoadValues({ commit }, payload) {
    commit('DELETE_BULKLOADVALUES', payload)
  },
  
  setBulkItemObjects({ commit }, payload) {
    commit('SET_BULKITEMOBJECTS', payload)
  },
  deleteBulkItemObjects({ commit }, payload) {
    commit('DELETE_BULKITEMOBJECTS', payload)
  },
  
  setBulkLoadObjects({ commit }, payload) {
    commit('SET_BULKLOADOBJECTS', payload)
  },
  deleteBulkLoadObjects({ commit }, payload) {
    commit('DELETE_BULKLOADOBJECTS', payload)
  },

  resetBulkStates({commit}) {
    commit('RESET_BULK_STATES')
  },

  setShipmentType({ commit }, payload) {
    commit('SET_SHIPMENTTYPE', payload)
  },
  
  setShipmentTypeFilters({ commit }, payload) {
    commit('SET_SHIPMENT_TYPE_FILTERS', payload)
  },
  
  setStatusTypeFilters({ commit }, payload) {
    commit('SET_STATUS_TYPE_FILTERS', payload)
  },
}
